// src/components/Modal.js
import React, { useEffect, useRef } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";

const Modal = ({ children, onClose }) => {
  const modalRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Close on escape key
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);

    // Prevent body scrolling when modal is open
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);
      document.body.style.overflow = "auto";
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black bg-opacity-80 backdrop-blur-sm" />
      
      <div className="relative z-10" ref={modalRef}>
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute -top-4 -right-4 w-8 h-8 rounded-full bg-gray-800 border border-gray-700 flex items-center justify-center text-gray-400 hover:text-white transition-colors z-20"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
        
        {/* Modal content */}
        <div className="relative">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
